import Head from "next/head"
import Image from "next/image"
import csatWebBanner from "../../assets/images/home/Mob_Banner/Pre-Prefit-Web-Banner.jpg";
import redrightarrow from "../../assets/images/contact/redrightarrow.png";
import Success from "../../assets/images/home/newicon/Success.jpg";
import Target1 from "../../assets/images/home/newicon/target.jpg";
import Faculty from "../../assets/images/home/newicon/Faculty.jpg";
import TestSeries from "../../assets/images/home/newicon/Testseries.jpg";
import CountUp from "react-countup";
import styles from "./prelims.module.css";
import NewiconA from "../../assets/images/header/newanimation.gif";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Link from "next/link";
import { useState, useEffect } from "react";

const UPSC_Prelims = () => {


    const feestructure = [
        { date: "GS Paper I", cont: "03.05.2026", cont1: "09:30 am to 11:30 am" },
        { date: "GS Paper II", cont: "03.05.2026", cont1: "02:30 pm to 04:30 pm" }
      ]
    
      const feestructure2 = [
        { date: "GS Paper I", cont: "10.05.2026", cont1: "09:30 am to 11:30 am" },
        { date: "GS Paper II", cont: "10.05.2026", cont1: "02:30 pm to 04:30 pm" }
      ]
    
      const feestructure3 = [
        { date: "GS Paper I", cont: "17.5.2026", cont1: "09:30 am to 11:30 am" },
        { date: "GS Paper II", cont: "17.5.2026", cont1: "02:30 pm to 04:30 pm"}
      ]

      const stats = [
        { value: 2900, suffix: "+", label: "IAS, IPS & IFS Selections", delay: 100 },
        { value: 202, label: "of 958 | UPSC CSE 2025", delay: 200 },
        { value: 9, label: "Govt Partnerships", delay: 300 },
    ];

    const jsonLd ={
        "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "UPSC Prelims Test Series 2025 | Shankar IAS Academy",
            "url": "https://www.shankariasacademy.com/upsc-prelims-test-series/",
            "description": "Join Shankar IAS Academy's UPSC Prelims Test Series 2025. Weekly test series, expert analysis & feedback to maximize your exam performance.  "
    }

    const targetDate = '2025-05-25T23:59:59+05:30';
    const calculateTimeLeft = () => {
        const nowIST = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
        // Reset the time to midnight
        nowIST.setHours(0, 0, 0, 0);
    
        // Parse the target date (which already includes the IST offset)
        const target = new Date(targetDate);
        // Reset the target's time to midnight
        target.setHours(0, 0, 0, 0);
    
        const difference = target - nowIST;
        const days = difference > 0 ? Math.floor(difference / (1000 * 60 * 60 * 24)) : 0;
    
        // Optionally, if you need hours, minutes, and seconds for display (from the remaining time today):
        const now = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
        const remainingToday = (nowIST.getTime() + 24 * 60 * 60 * 1000) - now.getTime();
        const hours = Math.floor((remainingToday / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((remainingToday / (1000 * 60)) % 60);
        const seconds = Math.floor((remainingToday / 1000) % 60);
    
        return { days, hours, minutes, seconds };
      };
   
      const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
    
      useEffect(() => {
        const timer = setInterval(() => {
          setTimeLeft(calculateTimeLeft());
        }, 1000);
    
        return () => clearInterval(timer);
      }, [targetDate]);

    return (
        <>
        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="noindex,nofollow" />
            <meta name="robots" content="noindex,nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title> UPSC Prelims Test Series 2025 | Shankar IAS Academy</title>
            <meta name="title" content="UPSC Prelims Test Series 2025 | Shankar IAS Academy" />
            <meta name="description" content="Join Shankar IAS Academy's UPSC Prelims Test Series 2025. Weekly test series, expert analysis & feedback to maximize your exam performance." />
            <link rel="canonical" href="https://www.shankariasacademy.com/upsc-prelims-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content=" UPSC Prelims Test Series 2025 | Shankar IAS Academy" />
            <meta property="og:description" content=" Join Shankar IAS Academy's UPSC Prelims Test Series 2025. Weekly test series, expert analysis & feedback to maximize your exam performance. " />
            <meta property="og:url" content="https://www.shankariasacademy.com/upsc-prelims-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

  <Navbar title="about" />

   <div className="container">
        <div className="row">
            <div className="col pt-3 pt-md-4">
               <h1 className={`${styles.heading3d}`}>UPSC Prelims Test Series 2026</h1>

              <div className='row pt-2'>
            <div className={`${styles.admincontent} d-md-block d-none col-12 col-md-6 pt-2`}>
                <div className={styles.heroCard} data-aos="fade-right">
                    <span className={styles.badge}>India's Trusted UPSC Coaching</span>
                    <h1 className={styles.title}>
                        Best IAS Coaching in India
                        <span> Shankar IAS Academy Chennai</span>
                    </h1>
                    <p className={styles.description}>
                       Shankar IAS Academy stands as a pioneer in UPSC coaching, earning the reputation of being the Best IAS Academy in India through its consistent <b>track record</b> of producing top-ranking civil servants.
                    </p>
                            {/* Stats */}
                    <div className={styles.statsRow}>
                        {stats.map((item, index) => (
                            <div
                                key={index}
                                className={styles.statCircle}
                                data-aos="zoom-in"
                                data-aos-delay={item.delay}
                                >
                                <span className={styles.circleGlow}></span>
                                <h3>
                                    <CountUp
                                    end={item.value}
                                    duration={6.5}
                                    suffix={item.suffix || ""}
                                    />
                                </h3>
                                <p>{item.label}</p>
                            </div>
                        ))}
                    </div>

                    {/* Features */}
                    <div className={`${styles.featureGrid} pt-3`}>

                        <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="400">
                            <span><Image src={Success} width="36" height="36" alt="New_icon" className="img-fluid mx-2" /></span>  High Success Rate 
                        </div>

                        <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="500">
                            <span><Image src={Target1} width="46" height="4 6" alt="New_icon" className="img-fluid mx-2" /></span> Prelims & Mains Integrated Coaching
                        </div>

                        <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="600">
                            <span><Image src={Faculty} width="46" height="46" alt="New_icon" className="img-fluid mx-2" /></span>Expert Faculty & Mentorship
                        </div>

                        <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="700">
                            <span><Image src={TestSeries} width="36" height="36" alt="New_icon" className="img-fluid mx-2" /></span>Advanced Test Series
                        </div>

                    </div>

                    {/* <div  className={`${styles.newachievernumber1} text-end pt-4 d-none d-md-block`} data-aos="fade-up" data-aos-delay="400">
                        <Link href="#" className={`${styles.acheivermore}`} id=""  onclick="fbq('track', 'ButtonClick');">
                             <span style={{ color: "rgb(66, 60, 60)", fontWeight:"bold", fontSize:"16px" }}>& More</span> <Image src={redrightarrow} className={`${styles.logoimg} img-fluid`} alt="Chennai Icon" width={20} height={20} />
                        </Link>
                    </div> */}
                </div>
            </div>

            <div className="col-md-6 pt-3">
                <Image src={csatWebBanner} className="img-fluid w-100" alt="Free All India Prelims Mock Test" title="Free All India Prelims Mock Test" />
            </div>      
        </div> 
            </div>
        </div>
   </div>

   <div className="container">
        <div className="row">
        <div className="co-12 mb-3">
                
                {/* <div className="col-md-8 offset-md-2">
                  <h5 className={` text-center pt-5`}>UPSC Prelims Exam Countdown 2025</h5>
                  <div className="row text-center pt-2">
                      <div className="col-md-2 pb-2 pt-2" style={{
                                      border: " 1px solid rgb(201, 199, 193)",
                                      opacity: "1",fontSize:"25px",color:"rgb(255, 0, 0)",backgroundColor:"rgb(242, 243, 245)"
                                  }}>{timeLeft.days}<br />Days</div><div className="col-md-3" style={{
                                      border: " 1px solid rgb(201, 199, 193)",
                                      opacity: "1",fontSize:"25px",color:"rgb(255, 0, 0)",marginLeft:"5px",backgroundColor:"rgb(242, 243, 245)"
                                  }}>{timeLeft.hours}<br /> Hours</div>  <div className="col-md-3" style={{
                                      border: " 1px solid rgb(201, 199, 193)", marginLeft:"5px",
                                      opacity: "1",fontSize:"25px",color:"rgb(255, 0, 0)",backgroundColor:"rgb(242, 243, 245)"
                                  }}>{timeLeft.minutes}<br /> Minutes</div>  <div className="col-md-3" style={{
                                      border: " 1px solid rgb(201, 199, 193)", marginLeft:"5px",
                                      opacity: "1",fontSize:"25px",color:"rgb(255, 0, 0)",backgroundColor:"rgb(242, 243, 245)"
                                  }}> {timeLeft.seconds}<br /> Seconds</div>
                  </div>
                </div> */}
                 </div>
                 <div className="container">
                        <div className={`${styles.roadmapStart} p-4`}>
                            <p>To elevate your 2025 UPSC preparation, we offer a complete <span style={{ color: '#a52a2a',  }}> UPSC Prelims Test Series,</span> which is specifically designed to help you improve your chances of success in the Civil Service Examination.
                            Shankar IAS Academy's <span style={{ color: '#a52a2a',  }}> "UPSC Prestorming Test series 2025"</span> offers a complete syllabus coverage and in-depth analysis of the country's most challenging competitive examination.
                            Our Exclusive UPSC Prelims Test Series is designed especially for the current UPSC exam and the patterns that have been observed in the exams.</p>
                       </div>
                 </div>
                <div className="col py-md-3 py-3">
                    <div className="row">
                        <div className="col-lg-6 col-12 mb-3">
                            <div className={`${styles.classesborder} h-100`} style={{
                                background: "#FFF8EA 0% 0% no-repeat padding-box", border: " 1px solid #D9DFE6",
                                opacity: "1"
                            }}>
                            <div className={`${styles.whyboxboxheight} p-4`}>
                                <Link href="/upsc-prestorming-prelims-test-series">
                                    <button className={`${styles.normalbutton}`} type="submit">
                                        PRESTORMING 2024 - 2025
                                    </button>
                                </Link>
                                <p className={`${styles.acheivername} pt-3 mx-3`}>Weekly Test Series</p>
                                <ul>
                                   <li className={`${styles.acheiverrank}`}>67 questions reflected in UPSC Prelims from Prestorming 2024, IAS Parliament website and Civilspedia</li>
                                   <li className={`${styles.acheiverrank} pt-2`}>43 exclusive tests and 5 UPSC mock tests</li>
                                   <li className={`${styles.acheiverrank} pt-2`}>17 comprehensive CSAT tests</li>
                                    <li className={`${styles.acheiverrank} pt-2`}>Orientation and Discussion for each test</li>
                                </ul>
                            </div>

                            <hr className="mb-0" />
                            
                            <div className="px-4 pb-1 py-md-2 " style={{ backgroundColor: "#FFFFFF" }}>
                                {/* result page */}
                                <Link href="/upsc-prestorming-prelims-test-series">
                                    <div className="row">
                                        <div className="col-9 col-xl-10 align-self-center">
                                            <p className={`${styles.redunderline} mb-0`} id={styles.directionline}>Click Here</p>
                                        </div>
                                        <div className="col-3 col-xl-2">
                                            <Image src={redrightarrow} className="img-fluid" alt="arrow icon" title="Link" />
                                        </div>
                                    </div>
                                </Link>
                            </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-12 mb-3">
                            <div className={`${styles.classesborder} h-100`} style={{
                                            background: "#E2F6FF 0% 0% no-repeat padding-box", border: " 1px solid #D9DFE6",
                                            opacity: "1"
                                        }}>
                                            <div className={`${styles.whyboxboxheight} p-4`}>
                                            <Link href="/upsc-prefit-prelims-test-series">
                                                <button className={`${styles.normalbutton}`} type="submit">
                                                PRELIMS FITNESS (PREFIT) 2025
                                                </button> <span><Image src={NewiconA} width="34" height="34" alt="New_icon" className="img-fluid mx-2" /></span>
                                            </Link>
                                            <p className={`${styles.acheivername} pt-3 mx-3`}>Daily Test Series</p>
                                                <ul>
                                                    <li className={`${styles.acheiverrank} `}>34 questions reflected in UPSC Prelims from Prefit 2024</li>
                                                    <li className={`${styles.acheiverrank} pt-2`}>Total number of test 54</li>
                                                    <li className={`${styles.acheiverrank} pt-2`}>31 Half Test+ 11 Revision / Full tests and 3 UPSC mock tests</li>
                                                    <li className={`${styles.acheiverrank} pt-2`}>9 comprehensive CSAT tests</li>
                                                    <li className={`${styles.acheiverrank} pt-2`}>Recorded Discussion for each test</li>
                                                </ul>
                                            </div>
                                            <hr className="mb-0" />
                                            <div className="px-4 pb-1 py-md-2 " style={{ backgroundColor: "#FFFFFF" }}>
                                                {/* upsc visiting faculty */}
                                                <Link href="/upsc-prefit-prelims-test-series">
                                                    <div className="row">
                                                        <div className="col-9 col-xl-10 align-self-center">
                                                            <p className={`${styles.redunderline} mb-0`} id={styles.directionline}>Click Here</p>
                                                        </div>
                                                        <div className="col-3 col-xl-2">
                                                            <Image src={redrightarrow} className="img-fluid" alt="arrow icon" title="Link" />
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
   </div>


   <div className="container roadmaphead">
       
   </div>

   <div className="container pt-2 pb-2">
  
   <h4 className="" style={{ color: "#a52a2a" }}>
  The Strategic Road Map to the UPSC Prelims 2025:
</h4>
    
  
   
    <div className={styles.roadmapContainer}>
    <div className={`${styles.roadmaphead} pb-4`}>
     <p>As an overall strategy to get through one of the world's toughest competitive exams, we provide different levels of Weekly, Daily and All-India Mock Test series in our institute for both FRESHERS AND VETERANS.</p>
   </div>
      <div className={styles.roadmap}>
        <div className={styles.roadmapStep} id="step1">
          <div className={styles.stepNumber}></div>
          <h2>Daily Test Series</h2>
          <p>For a more frequent schedule, the UPSC Prelims Prefit 2025 (UPSC Prelims Daily Test Series) breaks down the practice into manageable daily tasks to support learning.</p>
        </div>
        <div className={styles.roadmapLine}></div>
        <div className={styles.roadmapStep} id="step2">
          <div className={styles.stepNumber}></div>
          <h2>Weekly Test Series</h2>
          <p>For those who require a more scheduled approach, our UPSC Prelims Prestorming 2025 (UPSC Prelims Weekly Test Series) offers regular practice and assessment.</p>
        </div>
        <div className={styles.roadmapLine}></div>
        <div className={styles.roadmapStep3} id="step3">
          <div className={styles.stepNumber}></div>
          <h2>All India Mock Tests</h2>
          <p>The final phase is the launch, where we release the project to the public and monitor its performance.</p>
        </div>
      </div>
      <div className={`${styles.roadmaphead} pt-4`}>
       <p> Our UPSC Prelims Test Series 2025 covers both Static and Dynamic subject topics, thereby covering all the aspects of your preparation.</p>
     </div>
    </div>
   
</div>

<div className="container pt-2 pb-2">
    <h5 className="" style={{ color: "#a52a2a" }}>
      Beyond just testing, we focus on learning:
    </h5>

     <div className={`${styles.roadmaphead} p-4 `}>
            <p> The highlight of the UPSC Prestorming Test Series is that we give DETAILED EXPLANATION along with ADDITIONAL INFORMATION, which provides a
            deeper understanding of the concepts and enables you to learn beyond the question.</p>

            <p>We pride ourselves on the REFLECTION OF OUR QUESTIONS IN THE ACTUAL UPSC EXAMINATION, which is a testament to the quality and relevance of our content.</p>
            
            <p>Our experienced team of experts carefully analyses previous years' UPSC papers and incorporates the latest trends into our question design, ensuring that you are well-prepared for the actual exam.</p>
       </div>

</div>


<div className="container">
    <h5 className="" style={{ color: "#a52a2a" }}>
      Stay Updated:
    </h5>

    <div className={`${styles.roadmaphead} p-4 `}>
        <p> Current affairs are crucial for the UPSC Prelims, and our integrated UPSC Prelims Test Series incorporates consistent CURRENT AFFAIRS UPDATES WITH EXCLUSIVE CURRENT AFFAIRS TESTS, allowing the candidates to integrate the current affairs knowledge into their rigorous preparation seamlessly.</p>
    </div>
</div>


<div className="container">
    <h5 className="" style={{ color: "#a52a2a" }}>
    Online & Offline Options:
    </h5>

    <div className={`${styles.roadmaphead} p-4 `}>
        <p> We offer all our test series, both online and offline, which intends to cater to the diverse needs of students coming from varied backgrounds.</p>
        <p>To further enhance your learning experience, we conduct LIVE OFFLINE & ONLINE TEST DISCUSSION with our experienced faculty team, which provides an interactive opportunity for the aspirants to clarify doubts, discuss different approaches to answer the questions and gain valuable insights over the overall test paper.</p>
    </div>
</div>

<div className="container">
    <h5 className="" style={{ color: "#a52a2a" }}>
    Monitor your progress:
    </h5>

    <div className={`${styles.roadmaphead} p-4 `}>
        <p>Our exclusive SELF-ASSESSING ONLINE PORTAL allows students to track their progress, identify the weak areas and help them focus on their strengths in each exam.</p>
        <p>This personalized feedback mechanism empowers students to optimize their preparation strategy and maximize their scores.</p>
    </div>
</div>

<div className="container">
    <h5 className="" style={{ color: "#a52a2a" }}>
    Begin your journey to success.
    </h5>

    <div className={`${styles.roadmaphead} p-4 `}>
        <p>Take the first step of your journey towards a rewarding career in civil service by joining our exclusive UPSC Prelims Test Series 2025.</p>
       
    </div>
</div>


 <Footer />
        </>
    )
}

export default UPSC_Prelims